import { type NonOptional } from 'valibot'

// 運行実績のquery型からorderを取り出してるが、全てのqueryで共通の型
import { type Methods } from '../../aspida/api/_tenant@string/tours'

/**
 * ソート順種別
 */
export type SortOrderType = NonOptional<
  Required<Methods['get']>['query']['order']
>

export const SORT_ORDER_TYPE = {
  /** 昇順 */
  ASC: 'ASC',
  /** 降順 */
  DESC: 'DESC'
} as const satisfies Record<SortOrderType, SortOrderType>
